import { useEffect } from "react";

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

function ReCaptchaScriptLoader() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return null;
}

export default ReCaptchaScriptLoader;
